module.exports = __webpack_public_path__ + "6b83ab95bd23daca2408f78d9381af8c.svg";